var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("app-divider", { attrs: { label: "Dados Gerais" } }),
      _c(
        "el-row",
        { attrs: { gutter: 30 } },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-row",
                [
                  _c("app-label", {
                    staticClass: "margin-button",
                    attrs: { label: "Código " + _vm.ORGAO, required: true }
                  })
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c("validation-provider", {
                    attrs: { rules: "required" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var errors = ref.errors
                          return [
                            _c("el-input", {
                              staticClass: "input",
                              class: { erro: errors.length },
                              attrs: { name: "Codigo", maxlength: 100 },
                              on: {
                                blur: function($event) {
                                  return _vm.$emit(
                                    "setCodigo",
                                    $event.target.value
                                  )
                                }
                              },
                              model: {
                                value: _vm.numero,
                                callback: function($$v) {
                                  _vm.numero = $$v
                                },
                                expression: "numero"
                              }
                            }),
                            _c("span", { staticClass: "help erro" }, [
                              _vm._v(_vm._s(errors[0]))
                            ])
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-77ba1795", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77ba1795","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppDadosGeraisOs.vue
// module id = null
// module chunks = 